import Multiple from './Multiple'
import Single from './Single'

export default { Multiple, Single }
